import React from "react";

export default function GoogleLogoSVG(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_480_489)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 3.86666C11.8777 3.86666 13.1444 4.67778 13.8667 5.35556L16.6889 2.6C14.9555 0.988886 12.7 0 10 0C6.08887 0 2.71109 2.24444 1.06665 5.51111L4.29998 8.02221C5.11109 5.61111 7.35552 3.86666 10 3.86666Z"
          fill="#EA4335"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.6 10.2222C19.6 9.39995 19.5334 8.79995 19.3889 8.17773H10V11.8888H15.5111C15.4 12.8111 14.8 14.1999 13.4666 15.1333L16.6222 17.5777C18.5111 15.8333 19.6 13.2666 19.6 10.2222Z"
          fill="#4285F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.31111 11.9778C4.1 11.3556 3.97778 10.6889 3.97778 10C3.97778 9.31114 4.1 8.64443 4.3 8.02222L1.06666 5.51111C0.388889 6.86667 0 8.38886 0 10C0 11.6111 0.388889 13.1334 1.06666 14.4889L4.31111 11.9778Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0001 20C12.7001 20 14.9668 19.1111 16.6224 17.5778L13.4668 15.1334C12.6224 15.7222 11.489 16.1334 10.0001 16.1334C7.35564 16.1334 5.11122 14.3889 4.31122 11.9778L1.07788 14.4889C2.72233 17.7556 6.08899 20 10.0001 20Z"
          fill="#34A853"
        />
      </g>
      <defs>
        <clipPath id="clip0_480_489">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}